/**
 * @file Automatically generated by barrelsby.
 */

export * from './tab.content-load.on.demand-directive';
